import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from 'services/config/config.service';
import { TokenService } from 'services/token/token-service.service';

@Injectable({
  providedIn: 'root',
})
export class ApiRequestService {
  constructor(
    public http: HttpClient,
    public tokenService: TokenService,
    public configService: ConfigService,
  ) { }

  public post(path: string, body: any) {
    const headers = new HttpHeaders({
      Authorization: this.tokenService.getIdToken(),
    });

    return this.http.post<any>(this.configService.getConfig().apiUrl + path, body, { headers });
  }

  public get(path: string) {
    const headers = new HttpHeaders({
      Authorization: this.tokenService.getIdToken(),
    });

    return this.http.get<any>(this.configService.getConfig().apiUrl + path, { headers });
  }

  public put(path: string, body: any) {
    const headers = new HttpHeaders({
      Authorization: this.tokenService.getIdToken(),
    });

    return this.http.put<any>(this.configService.getConfig().apiUrl + path, body, { headers });
  }

  public delete(path: string, body: any) {
    const headers = new HttpHeaders({
      Authorization: this.tokenService.getIdToken(),
    });

    return this.http.delete<any>(this.configService.getConfig().apiUrl + path, { headers });
  }
}
